import axios from "axios";

function resolveApiBase() {
  // Capacitor Android uygulaması, paketlenmiş arayüzü HTTPS localhost kökeninden
  // çalıştırır. Web sürümündeki göreli /api adresi burada uygulamanın içine
  // yönelirdi; bu nedenle yalnızca native kabukta canlı Takofy API'sini kullanırız.
  const isNativeApp = typeof window !== "undefined" &&
    typeof window.Capacitor?.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform();

  if (isNativeApp) {
    return "https://takofy.com/api";
  }

  const raw = String(process.env.REACT_APP_API_BASE || "").trim();

  if (!raw && typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }

  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    return raw.replace(/\/+$/, "");
  }

  if (raw.startsWith("/") && typeof window !== "undefined") {
    return `${window.location.origin}${raw}`.replace(/\/+$/, "");
  }

  return raw.replace(/\/+$/, "");
}

const API_BASE = resolveApiBase();

if (!API_BASE) {
  console.error("❌ REACT_APP_API_BASE is not defined");
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const headers = config.headers || {};
  const data = config.data;

  if (typeof FormData !== "undefined" && data instanceof FormData) {
    if (headers["Content-Type"]) delete headers["Content-Type"];
    if (headers["content-type"]) delete headers["content-type"];
  } else if (!headers["Content-Type"] && !headers["content-type"]) {
    headers["Content-Type"] = "application/json";
  }

  config.headers = headers;
  return config;
});

const RETRYABLE_STATUS_CODES = new Set([502, 503, 504]);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    const status = Number(error?.response?.status || 0);
    const method = String(config?.method || "get").toLowerCase();

    if (!config || config.signal?.aborted) {
      throw error;
    }

    const shouldRetry =
      method === "get" &&
      !config.__authRetry &&
      RETRYABLE_STATUS_CODES.has(status) &&
      !String(config.url || "").includes("/auth/me");

    if (status === 401 && typeof window !== "undefined" && !String(config?.url || "").includes("/auth/login") && !String(config?.url || "").includes("/auth/me")) {
      window.dispatchEvent(new CustomEvent("takofy:session-expired"));
    }

    if (!shouldRetry) {
      throw error;
    }

    config.__authRetry = true;
    await new Promise((resolve) => setTimeout(resolve, 350));
    return api.request(config);
  }
);

export default api;
